import SEO from "@/components/SEO";

export default function TermsPage() {
  return (
    <div className="max-w-[900px] mx-auto px-6 lg:px-10 py-16">
      <SEO title="Terms & Conditions" description="Noxi's terms of service — fees, payouts, disputes, intellectual property, and acceptable use."/>
      <div className="overline text-primary mb-2">◆ TERMS & CONDITIONS</div>
      <h1 className="text-4xl font-bold tracking-tight mb-2">Terms of Service</h1>
      <p className="mono text-xs opacity-60 mb-10">Last updated: 18 Sep 2026</p>

      <div className="prose prose-neutral max-w-none space-y-6 text-foreground/90 leading-relaxed text-[15px]">
        <Section n="1" title="Acceptance">
          By creating an account or using Noxi ("we", "us", "the platform"), you agree to these Terms of Service and our Privacy Policy. If you don't agree, please don't use Noxi.
        </Section>
        <Section n="2" title="Eligibility">
          You must be at least 18 years old and legally able to enter contracts in your jurisdiction. You represent that all information you provide is true and current.
        </Section>
        <Section n="3" title="Accounts & security">
          You are responsible for maintaining the confidentiality of your account and for all activity under it. Notify us immediately if you suspect unauthorised access.
        </Section>
        <Section n="4" title="Marketplace role">
          Noxi is a marketplace that connects buyers and independent sellers ("Sellers"). Sellers are independent contractors — Noxi is not the employer or agent of any Seller.
        </Section>
        <Section n="5" title="Fees">
          Noxi charges a flat 20% platform fee on Seller earnings at the time of withdrawal. Payment provider fees (Stripe, Razorpay) may apply and are shown at checkout.
        </Section>
        <Section n="6" title="Payments & payouts">
          Buyer payments are held by Noxi until the order is delivered and accepted. Seller payouts are issued to the bank account on file after admin review and typically settle within 3–7 business days.
        </Section>
        <Section n="7" title="Orders, revisions & disputes">
          Each package defines the number of revisions. Buyers can request revisions within the delivered window. Disputes can be opened from any paid, active order and are resolved by Noxi's admin team; outcomes include refunds, releases, or split settlements.
        </Section>
        <Section n="8" title="Prohibited content">
          You may not use Noxi to sell illegal goods or services, plagiarised work, adult/explicit content, weapons, or anything that infringes intellectual property.
        </Section>
        <Section n="9" title="Intellectual property">
          Unless otherwise agreed in the gig or a separate contract, deliverables become the Buyer's property after full payment. Sellers retain the right to feature the work in a portfolio unless the Buyer explicitly requests non-disclosure.
        </Section>
        <Section n="10" title="Limitation of liability">
          To the maximum extent permitted by law, Noxi is not liable for indirect, incidental, special, consequential, or punitive damages arising from your use of the platform.
        </Section>
        <Section n="11" title="Termination">
          We may suspend or terminate accounts that violate these terms or applicable law. You may close your account at any time by contacting support.
        </Section>
        <Section n="12" title="Changes">
          We may update these Terms. Material changes will be announced in-app or via email. Continued use of Noxi means you accept the updated Terms.
        </Section>
        <Section n="13" title="Contact">
          Questions? Email <a className="text-primary" href="mailto:noxiiservices@gmail.com">noxiiservices@gmail.com</a>.
        </Section>
      </div>
    </div>
  );
}

function Section({ n, title, children }) {
  return (
    <div>
      <h2 className="text-lg font-semibold mb-2">{n}. {title}</h2>
      <p className="text-foreground/80">{children}</p>
    </div>
  );
}
